import { Controller } from "../../../Controller";
import {
    DesvincularDocumentoTemplateFormularioService,
    ListarDocumentoTemplateFormularioService,
    VincularDocumentoTemplateFormularioService,
} from "../../../../Services/Automacao/Formularios/ConfigTemplateFormulario/ConfigTemplateFormularioServices";
import { IVincularConfigTemplateFormulario } from "../../../../Interfaces/Automacao/Formularios/ConfigTemplateFormulario/ConfigTemplateFormularioInterfaces";

export async function VincularDocumentoTemplateFormularioController(
    vinculoDocumentoTemplateFormulario: IVincularConfigTemplateFormulario
) {
    return Controller(
        VincularDocumentoTemplateFormularioService(
            vinculoDocumentoTemplateFormulario
        )
    );
}

export async function ListarDocumentoTemplateFormularioController(
    idFormulario: number
) {
    return Controller(ListarDocumentoTemplateFormularioService(idFormulario));
}

export async function DesvincularDocumentoTemplateFormularioController(
    idDocTempFormulario: number
) {
    return Controller(
        DesvincularDocumentoTemplateFormularioService(idDocTempFormulario)
    );
}
